/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Tue, 24 Mar 2026 18:28:47 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import {
  ACHAccount,
  ACHAccountDetails,
  ACHBankInfo,
  ACHBusinessInfo,
  ACHUserInfoBase,
  BeneficiaryAccountDetails,
  BusinessRelationshipType,
  CompanyCheckingACHUserInfo,
  CompanyContact,
  CompanyContactForm,
  CompanySavingsACHUserInfo,
  Contact,
  ContactAddress,
  ContactBase,
  ContactFormBase,
  ContactType,
  COPAccount,
  COPAccountDetails,
  CreateContactRequest,
  CreateFiatAccountRequest,
  CreateFiatAccountResponse,
  CryptoAccount,
  CryptoAssetType,
  CryptoChain,
  CryptoPaymentForm,
  CVUAccount,
  CVUAccountDetails,
  FiatAccount,
  FiatPaymentACHWireFormBase,
  IndividualCheckingACHUserInfo,
  IndividualContact,
  IndividualContactForm,
  IndividualSavingsACHUserInfo,
  isAccountDetails,
  isACHUserInfoOrNull,
  isContactData,
  PaymentMethodBase,
  PixAccount,
  PIXAccountDetails,
  RecipientAccount,
  SearchableContact,
  SelfContact,
  SimplifiedAccount,
  SpeiAccount,
  SpeiAccountDetails,
  SwiftAccount,
  SwiftAccountDetails,
  SwiftBankInfo,
  SwiftBusinessInfo,
  SwiftUserInfo,
  UpdateContactRequest,
  UpdateContactRequestData,
  UpdateFiatAccountRequest,
  UpdateFiatAccountRequestData,
  WireAccount,
  WireAccountDetails,
  WireBankInfo,
  WireBusinessInfo,
  WireUserInfo,
} from '@/types/contacts';
import {
  isBoolean,
  isBooleanOrNull,
  isNull,
  isNumber,
  isString,
  isStringOrNull,
} from '@/types/common-type-guards';
import { isCountryType } from '@/types/country.ext';
import { isBankAccountType } from '@/types/bankAccountType.ext';
import { BankAccountType } from '@/types/bankAccountType';
import { isCopDocumentTypeOrNull } from '@/types/copDocumentType.ext';
import { isFiatAccountType } from '@/types/fiatAccountType.ext';
import { isCurrencyCodeType } from '@/types/currency.ext';
import { isCryptoCurrencyCodeType } from '@/types/simulation.ext';
import { isArrayOfRecipientResponse } from '@/types/recipient';
import { isPaymentMethodAccountType } from '@/types/paymentMethodAccountType.ext';
import { PaymentMethodAccountType } from '@/types/paymentMethodAccountType';
import { CountryType } from '@/types/country';

const valuesOfContactType: readonly string[] = ['NATURAL_PERSON', 'COMPANY'];

export const isContactType = (value: unknown): value is ContactType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfContactType.includes(value);
};

export const isContactTypeOrNull = (value: unknown): value is ContactType | null => {
  return value === null || isContactType(value);
};

export const isArrayOfContactType = (value: unknown): value is ContactType[] => {
  return Array.isArray(value) && value.every(isContactType);
};

export const isArrayOfContactTypeOrNull = (value: unknown): value is ContactType[] | null => {
  return value === null || isArrayOfContactType(value);
};

const valuesOfCryptoAssetType: readonly string[] = [''];

export const isCryptoAssetType = (value: unknown): value is CryptoAssetType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCryptoAssetType.includes(value);
};

export const isCryptoAssetTypeOrNull = (value: unknown): value is CryptoAssetType | null => {
  return value === null || isCryptoAssetType(value);
};

export const isArrayOfCryptoAssetType = (value: unknown): value is CryptoAssetType[] => {
  return Array.isArray(value) && value.every(isCryptoAssetType);
};

export const isArrayOfCryptoAssetTypeOrNull = (
  value: unknown,
): value is CryptoAssetType[] | null => {
  return value === null || isArrayOfCryptoAssetType(value);
};

const valuesOfCryptoChain: readonly string[] = [''];

export const isCryptoChain = (value: unknown): value is CryptoChain => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCryptoChain.includes(value);
};

export const isCryptoChainOrNull = (value: unknown): value is CryptoChain | null => {
  return value === null || isCryptoChain(value);
};

export const isArrayOfCryptoChain = (value: unknown): value is CryptoChain[] => {
  return Array.isArray(value) && value.every(isCryptoChain);
};

export const isArrayOfCryptoChainOrNull = (value: unknown): value is CryptoChain[] | null => {
  return value === null || isArrayOfCryptoChain(value);
};

const valuesOfBusinessRelationshipType: readonly string[] = [
  'SUPPLIER',
  'CUSTOMER',
  'PARTNER',
  'DISTRIBUTOR',
  'CONSULTANT',
  'AFFILIATE',
  'INVESTOR',
  'FRANCHISEE',
  'FRANCHISOR',
  'CONTRACTOR',
  'SUBCONTRACTOR',
  'STRATEGIC_PARTNER',
  'RESELLER',
  'AGENT',
  'CLIENT',
  'BROKER',
  'LICENSEE',
  'LICENSOR',
  '',
];

export const isBusinessRelationshipType = (value: unknown): value is BusinessRelationshipType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfBusinessRelationshipType.includes(value);
};

export const isBusinessRelationshipTypeOrNull = (
  value: unknown,
): value is BusinessRelationshipType | null => {
  return value === null || isBusinessRelationshipType(value);
};

export const isArrayOfBusinessRelationshipType = (
  value: unknown,
): value is BusinessRelationshipType[] => {
  return Array.isArray(value) && value.every(isBusinessRelationshipType);
};

export const isArrayOfBusinessRelationshipTypeOrNull = (
  value: unknown,
): value is BusinessRelationshipType[] | null => {
  return value === null || isArrayOfBusinessRelationshipType(value);
};

export const isIndividualContact = (value: unknown): value is IndividualContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === ContactType.individual)) return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if (!('lastName' in value && isString(value.lastName))) return false;
  if (!('businessRelationship' in value && isBusinessRelationshipType(value.businessRelationship)))
    return false;

  return true;
};

export const isIndividualContactOrNull = (value: unknown): value is IndividualContact | null => {
  return value === null || isIndividualContact(value);
};

export const isArrayOfIndividualContact = (
  value: unknown,
): value is readonly IndividualContact[] => {
  return Array.isArray(value) && value.every(isIndividualContact);
};

export const isArrayOfIndividualContactOrNull = (
  value: unknown,
): value is readonly IndividualContact[] | null => {
  return value === null || isArrayOfIndividualContact(value);
};

const propertiesOfIndividualContact: readonly string[] = [
  'type',
  'firstName',
  'lastName',
  'businessRelationship',
];

export const isKeyOfIndividualContact = (value: unknown): value is keyof IndividualContact => {
  return typeof value === 'string' && propertiesOfIndividualContact.includes(value);
};

export const isCompanyContact = (value: unknown): value is CompanyContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === ContactType.company)) return false;
  if (!('legalEntityName' in value && isString(value.legalEntityName))) return false;
  if (!('businessRelationship' in value && isBusinessRelationshipType(value.businessRelationship)))
    return false;

  return true;
};

export const isCompanyContactOrNull = (value: unknown): value is CompanyContact | null => {
  return value === null || isCompanyContact(value);
};

export const isArrayOfCompanyContact = (value: unknown): value is readonly CompanyContact[] => {
  return Array.isArray(value) && value.every(isCompanyContact);
};

export const isArrayOfCompanyContactOrNull = (
  value: unknown,
): value is readonly CompanyContact[] | null => {
  return value === null || isArrayOfCompanyContact(value);
};

const propertiesOfCompanyContact: readonly string[] = [
  'type',
  'legalEntityName',
  'businessRelationship',
];

export const isKeyOfCompanyContact = (value: unknown): value is keyof CompanyContact => {
  return typeof value === 'string' && propertiesOfCompanyContact.includes(value);
};

export const isContactAddress = (value: unknown): value is ContactAddress => {
  if (value === null || typeof value !== 'object') return false;
  if (!('street' in value && isString(value.street))) return false;
  if (!('complement' in value && isString(value.complement))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('zipCode' in value && isString(value.zipCode))) return false;

  return true;
};

export const isContactAddressOrNull = (value: unknown): value is ContactAddress | null => {
  return value === null || isContactAddress(value);
};

export const isArrayOfContactAddress = (value: unknown): value is readonly ContactAddress[] => {
  return Array.isArray(value) && value.every(isContactAddress);
};

export const isArrayOfContactAddressOrNull = (
  value: unknown,
): value is readonly ContactAddress[] | null => {
  return value === null || isArrayOfContactAddress(value);
};

const propertiesOfContactAddress: readonly string[] = [
  'street',
  'complement',
  'city',
  'state',
  'zipCode',
];

export const isKeyOfContactAddress = (value: unknown): value is keyof ContactAddress => {
  return typeof value === 'string' && propertiesOfContactAddress.includes(value);
};

export const isBeneficiaryAccountDetails = (value: unknown): value is BeneficiaryAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('address' in value && isContactAddress(value.address))) return false;
  if (!('legalEntityName' in value && isString(value.legalEntityName))) return false;
  if (!('country' in value && isCountryType(value.country))) return false;

  return true;
};

export const isBeneficiaryAccountDetailsOrNull = (
  value: unknown,
): value is BeneficiaryAccountDetails | null => {
  return value === null || isBeneficiaryAccountDetails(value);
};

export const isArrayOfBeneficiaryAccountDetails = (
  value: unknown,
): value is readonly BeneficiaryAccountDetails[] => {
  return Array.isArray(value) && value.every(isBeneficiaryAccountDetails);
};

export const isArrayOfBeneficiaryAccountDetailsOrNull = (
  value: unknown,
): value is readonly BeneficiaryAccountDetails[] | null => {
  return value === null || isArrayOfBeneficiaryAccountDetails(value);
};

const propertiesOfBeneficiaryAccountDetails: readonly string[] = [
  'address',
  'legalEntityName',
  'country',
];

export const isKeyOfBeneficiaryAccountDetails = (
  value: unknown,
): value is keyof BeneficiaryAccountDetails => {
  return typeof value === 'string' && propertiesOfBeneficiaryAccountDetails.includes(value);
};

export const isWireUserInfo = (value: unknown): value is WireUserInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('street1' in value && isString(value.street1))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('routingKey' in value && isString(value.routingKey))) return false;
  if (!('accountNumber' in value && isString(value.accountNumber))) return false;
  if (!('accountType' in value && isBankAccountType(value.accountType))) return false;
  if (!('type' in value && isContactType(value.type))) return false;

  return true;
};

export const isWireUserInfoOrNull = (value: unknown): value is WireUserInfo | null => {
  return value === null || isWireUserInfo(value);
};

export const isArrayOfWireUserInfo = (value: unknown): value is readonly WireUserInfo[] => {
  return Array.isArray(value) && value.every(isWireUserInfo);
};

export const isArrayOfWireUserInfoOrNull = (
  value: unknown,
): value is readonly WireUserInfo[] | null => {
  return value === null || isArrayOfWireUserInfo(value);
};

const propertiesOfWireUserInfo: readonly string[] = [
  'name',
  'street1',
  'postalCode',
  'city',
  'state',
  'country',
  'routingKey',
  'accountNumber',
  'accountType',
  'type',
];

export const isKeyOfWireUserInfo = (value: unknown): value is keyof WireUserInfo => {
  return typeof value === 'string' && propertiesOfWireUserInfo.includes(value);
};

export const isWireBankInfo = (value: unknown): value is WireBankInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('bic' in value && isString(value.bic))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('street1' in value && isString(value.street1))) return false;
  if (!('street2' in value && isString(value.street2))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;

  return true;
};

export const isWireBankInfoOrNull = (value: unknown): value is WireBankInfo | null => {
  return value === null || isWireBankInfo(value);
};

export const isArrayOfWireBankInfo = (value: unknown): value is readonly WireBankInfo[] => {
  return Array.isArray(value) && value.every(isWireBankInfo);
};

export const isArrayOfWireBankInfoOrNull = (
  value: unknown,
): value is readonly WireBankInfo[] | null => {
  return value === null || isArrayOfWireBankInfo(value);
};

const propertiesOfWireBankInfo: readonly string[] = [
  'bic',
  'name',
  'street1',
  'street2',
  'postalCode',
  'city',
  'state',
  'country',
];

export const isKeyOfWireBankInfo = (value: unknown): value is keyof WireBankInfo => {
  return typeof value === 'string' && propertiesOfWireBankInfo.includes(value);
};

export const isWireBusinessInfo = (value: unknown): value is WireBusinessInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('address' in value && isString(value.address))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('registrationNumber' in value && isStringOrNull(value.registrationNumber))) return false;
  if (!('accountNumber' in value && isString(value.accountNumber))) return false;
  if (!('accountType' in value && isBankAccountType(value.accountType))) return false;
  if (!('routingNumber' in value && isString(value.routingNumber))) return false;
  if ('phoneNumber' in value && !isStringOrNull(value.phoneNumber)) return false;
  if ('registrationType' in value && !isStringOrNull(value.registrationType)) return false;
  if ('registrationDate' in value && !isStringOrNull(value.registrationDate)) return false;
  if ('registrationExpiryDate' in value && !isStringOrNull(value.registrationExpiryDate))
    return false;
  if ('mobileNumber' in value && !isStringOrNull(value.mobileNumber)) return false;
  if ('businessNature' in value && !isStringOrNull(value.businessNature)) return false;
  if ('email' in value && !isStringOrNull(value.email)) return false;

  return true;
};

export const isWireBusinessInfoOrNull = (value: unknown): value is WireBusinessInfo | null => {
  return value === null || isWireBusinessInfo(value);
};

export const isArrayOfWireBusinessInfo = (value: unknown): value is readonly WireBusinessInfo[] => {
  return Array.isArray(value) && value.every(isWireBusinessInfo);
};

export const isArrayOfWireBusinessInfoOrNull = (
  value: unknown,
): value is readonly WireBusinessInfo[] | null => {
  return value === null || isArrayOfWireBusinessInfo(value);
};

const propertiesOfWireBusinessInfo: readonly string[] = [
  'name',
  'address',
  'city',
  'state',
  'country',
  'postalCode',
  'registrationNumber',
  'accountNumber',
  'accountType',
  'routingNumber',
  'phoneNumber',
  'registrationType',
  'registrationDate',
  'registrationExpiryDate',
  'mobileNumber',
  'businessNature',
  'email',
];

export const isKeyOfWireBusinessInfo = (value: unknown): value is keyof WireBusinessInfo => {
  return typeof value === 'string' && propertiesOfWireBusinessInfo.includes(value);
};

export const isWireAccount = (value: unknown): value is WireAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('personInfo' in value && isWireUserInfoOrNull(value.personInfo))) return false;
  if (!('businessInfo' in value && isWireBusinessInfoOrNull(value.businessInfo))) return false;
  if (!('bankInfo' in value && isWireBankInfo(value.bankInfo))) return false;

  return true;
};

export const isWireAccountOrNull = (value: unknown): value is WireAccount | null => {
  return value === null || isWireAccount(value);
};

export const isArrayOfWireAccount = (value: unknown): value is readonly WireAccount[] => {
  return Array.isArray(value) && value.every(isWireAccount);
};

export const isArrayOfWireAccountOrNull = (
  value: unknown,
): value is readonly WireAccount[] | null => {
  return value === null || isArrayOfWireAccount(value);
};

const propertiesOfWireAccount: readonly string[] = ['personInfo', 'businessInfo', 'bankInfo'];

export const isKeyOfWireAccount = (value: unknown): value is keyof WireAccount => {
  return typeof value === 'string' && propertiesOfWireAccount.includes(value);
};

export const isACHUserInfoBase = (value: unknown): value is ACHUserInfoBase => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('street1' in value && isString(value.street1))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('routingKey' in value && isString(value.routingKey))) return false;
  if (!('accountNumber' in value && isString(value.accountNumber))) return false;
  if (!('accountType' in value && isBankAccountType(value.accountType))) return false;
  if (!('type' in value && isContactType(value.type))) return false;

  return true;
};

export const isACHUserInfoBaseOrNull = (value: unknown): value is ACHUserInfoBase | null => {
  return value === null || isACHUserInfoBase(value);
};

export const isArrayOfACHUserInfoBase = (value: unknown): value is readonly ACHUserInfoBase[] => {
  return Array.isArray(value) && value.every(isACHUserInfoBase);
};

export const isArrayOfACHUserInfoBaseOrNull = (
  value: unknown,
): value is readonly ACHUserInfoBase[] | null => {
  return value === null || isArrayOfACHUserInfoBase(value);
};

const propertiesOfACHUserInfoBase: readonly string[] = [
  'name',
  'street1',
  'postalCode',
  'city',
  'state',
  'country',
  'routingKey',
  'accountNumber',
  'accountType',
  'type',
];

export const isKeyOfACHUserInfoBase = (value: unknown): value is keyof ACHUserInfoBase => {
  return typeof value === 'string' && propertiesOfACHUserInfoBase.includes(value);
};

export const isCompanyCheckingACHUserInfo = (
  value: unknown,
): value is CompanyCheckingACHUserInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('accountType' in value && value.accountType === BankAccountType.checking)) return false;
  if (!('type' in value && value.type === ContactType.company)) return false;

  return true;
};

export const isCompanyCheckingACHUserInfoOrNull = (
  value: unknown,
): value is CompanyCheckingACHUserInfo | null => {
  return value === null || isCompanyCheckingACHUserInfo(value);
};

export const isArrayOfCompanyCheckingACHUserInfo = (
  value: unknown,
): value is readonly CompanyCheckingACHUserInfo[] => {
  return Array.isArray(value) && value.every(isCompanyCheckingACHUserInfo);
};

export const isArrayOfCompanyCheckingACHUserInfoOrNull = (
  value: unknown,
): value is readonly CompanyCheckingACHUserInfo[] | null => {
  return value === null || isArrayOfCompanyCheckingACHUserInfo(value);
};

const propertiesOfCompanyCheckingACHUserInfo: readonly string[] = ['accountType', 'type'];

export const isKeyOfCompanyCheckingACHUserInfo = (
  value: unknown,
): value is keyof CompanyCheckingACHUserInfo => {
  return typeof value === 'string' && propertiesOfCompanyCheckingACHUserInfo.includes(value);
};

export const isIndividualCheckingACHUserInfo = (
  value: unknown,
): value is IndividualCheckingACHUserInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('accountType' in value && value.accountType === BankAccountType.checking)) return false;
  if (!('type' in value && value.type === ContactType.individual)) return false;

  return true;
};

export const isIndividualCheckingACHUserInfoOrNull = (
  value: unknown,
): value is IndividualCheckingACHUserInfo | null => {
  return value === null || isIndividualCheckingACHUserInfo(value);
};

export const isArrayOfIndividualCheckingACHUserInfo = (
  value: unknown,
): value is readonly IndividualCheckingACHUserInfo[] => {
  return Array.isArray(value) && value.every(isIndividualCheckingACHUserInfo);
};

export const isArrayOfIndividualCheckingACHUserInfoOrNull = (
  value: unknown,
): value is readonly IndividualCheckingACHUserInfo[] | null => {
  return value === null || isArrayOfIndividualCheckingACHUserInfo(value);
};

const propertiesOfIndividualCheckingACHUserInfo: readonly string[] = ['accountType', 'type'];

export const isKeyOfIndividualCheckingACHUserInfo = (
  value: unknown,
): value is keyof IndividualCheckingACHUserInfo => {
  return typeof value === 'string' && propertiesOfIndividualCheckingACHUserInfo.includes(value);
};

export const isCompanySavingsACHUserInfo = (value: unknown): value is CompanySavingsACHUserInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('accountType' in value && value.accountType === BankAccountType.savings)) return false;
  if (!('type' in value && value.type === ContactType.company)) return false;

  return true;
};

export const isCompanySavingsACHUserInfoOrNull = (
  value: unknown,
): value is CompanySavingsACHUserInfo | null => {
  return value === null || isCompanySavingsACHUserInfo(value);
};

export const isArrayOfCompanySavingsACHUserInfo = (
  value: unknown,
): value is readonly CompanySavingsACHUserInfo[] => {
  return Array.isArray(value) && value.every(isCompanySavingsACHUserInfo);
};

export const isArrayOfCompanySavingsACHUserInfoOrNull = (
  value: unknown,
): value is readonly CompanySavingsACHUserInfo[] | null => {
  return value === null || isArrayOfCompanySavingsACHUserInfo(value);
};

const propertiesOfCompanySavingsACHUserInfo: readonly string[] = ['accountType', 'type'];

export const isKeyOfCompanySavingsACHUserInfo = (
  value: unknown,
): value is keyof CompanySavingsACHUserInfo => {
  return typeof value === 'string' && propertiesOfCompanySavingsACHUserInfo.includes(value);
};

export const isIndividualSavingsACHUserInfo = (
  value: unknown,
): value is IndividualSavingsACHUserInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('accountType' in value && value.accountType === BankAccountType.savings)) return false;
  if (!('type' in value && value.type === ContactType.individual)) return false;

  return true;
};

export const isIndividualSavingsACHUserInfoOrNull = (
  value: unknown,
): value is IndividualSavingsACHUserInfo | null => {
  return value === null || isIndividualSavingsACHUserInfo(value);
};

export const isArrayOfIndividualSavingsACHUserInfo = (
  value: unknown,
): value is readonly IndividualSavingsACHUserInfo[] => {
  return Array.isArray(value) && value.every(isIndividualSavingsACHUserInfo);
};

export const isArrayOfIndividualSavingsACHUserInfoOrNull = (
  value: unknown,
): value is readonly IndividualSavingsACHUserInfo[] | null => {
  return value === null || isArrayOfIndividualSavingsACHUserInfo(value);
};

const propertiesOfIndividualSavingsACHUserInfo: readonly string[] = ['accountType', 'type'];

export const isKeyOfIndividualSavingsACHUserInfo = (
  value: unknown,
): value is keyof IndividualSavingsACHUserInfo => {
  return typeof value === 'string' && propertiesOfIndividualSavingsACHUserInfo.includes(value);
};

export const isACHBankInfo = (value: unknown): value is ACHBankInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('routingNumber' in value && isString(value.routingNumber))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('street1' in value && isString(value.street1))) return false;
  if (!('street2' in value && isString(value.street2))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;

  return true;
};

export const isACHBankInfoOrNull = (value: unknown): value is ACHBankInfo | null => {
  return value === null || isACHBankInfo(value);
};

export const isArrayOfACHBankInfo = (value: unknown): value is readonly ACHBankInfo[] => {
  return Array.isArray(value) && value.every(isACHBankInfo);
};

export const isArrayOfACHBankInfoOrNull = (
  value: unknown,
): value is readonly ACHBankInfo[] | null => {
  return value === null || isArrayOfACHBankInfo(value);
};

const propertiesOfACHBankInfo: readonly string[] = [
  'routingNumber',
  'name',
  'street1',
  'street2',
  'postalCode',
  'city',
  'state',
  'country',
];

export const isKeyOfACHBankInfo = (value: unknown): value is keyof ACHBankInfo => {
  return typeof value === 'string' && propertiesOfACHBankInfo.includes(value);
};

export const isACHBusinessInfo = (value: unknown): value is ACHBusinessInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('address' in value && isString(value.address))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('registrationNumber' in value && isStringOrNull(value.registrationNumber))) return false;
  if (!('accountNumber' in value && isString(value.accountNumber))) return false;
  if (!('accountType' in value && isBankAccountType(value.accountType))) return false;
  if (!('routingNumber' in value && isString(value.routingNumber))) return false;
  if ('phoneNumber' in value && !isStringOrNull(value.phoneNumber)) return false;
  if ('registrationType' in value && !isStringOrNull(value.registrationType)) return false;
  if ('registrationDate' in value && !isStringOrNull(value.registrationDate)) return false;
  if ('registrationExpiryDate' in value && !isStringOrNull(value.registrationExpiryDate))
    return false;
  if ('mobileNumber' in value && !isStringOrNull(value.mobileNumber)) return false;
  if ('businessNature' in value && !isStringOrNull(value.businessNature)) return false;
  if ('email' in value && !isStringOrNull(value.email)) return false;

  return true;
};

export const isACHBusinessInfoOrNull = (value: unknown): value is ACHBusinessInfo | null => {
  return value === null || isACHBusinessInfo(value);
};

export const isArrayOfACHBusinessInfo = (value: unknown): value is readonly ACHBusinessInfo[] => {
  return Array.isArray(value) && value.every(isACHBusinessInfo);
};

export const isArrayOfACHBusinessInfoOrNull = (
  value: unknown,
): value is readonly ACHBusinessInfo[] | null => {
  return value === null || isArrayOfACHBusinessInfo(value);
};

const propertiesOfACHBusinessInfo: readonly string[] = [
  'name',
  'address',
  'city',
  'state',
  'country',
  'postalCode',
  'registrationNumber',
  'accountNumber',
  'accountType',
  'routingNumber',
  'phoneNumber',
  'registrationType',
  'registrationDate',
  'registrationExpiryDate',
  'mobileNumber',
  'businessNature',
  'email',
];

export const isKeyOfACHBusinessInfo = (value: unknown): value is keyof ACHBusinessInfo => {
  return typeof value === 'string' && propertiesOfACHBusinessInfo.includes(value);
};

export const isACHAccount = (value: unknown): value is ACHAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('personInfo' in value && isACHUserInfoOrNull(value.personInfo))) return false;
  if (!('businessInfo' in value && isACHBusinessInfoOrNull(value.businessInfo))) return false;
  if (!('bankInfo' in value && isACHBankInfo(value.bankInfo))) return false;

  return true;
};

export const isACHAccountOrNull = (value: unknown): value is ACHAccount | null => {
  return value === null || isACHAccount(value);
};

export const isArrayOfACHAccount = (value: unknown): value is readonly ACHAccount[] => {
  return Array.isArray(value) && value.every(isACHAccount);
};

export const isArrayOfACHAccountOrNull = (
  value: unknown,
): value is readonly ACHAccount[] | null => {
  return value === null || isArrayOfACHAccount(value);
};

const propertiesOfACHAccount: readonly string[] = ['personInfo', 'businessInfo', 'bankInfo'];

export const isKeyOfACHAccount = (value: unknown): value is keyof ACHAccount => {
  return typeof value === 'string' && propertiesOfACHAccount.includes(value);
};

export const isSwiftUserInfo = (value: unknown): value is SwiftUserInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('street1' in value && isString(value.street1))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('routingKey' in value && isString(value.routingKey))) return false;
  if (!('iban' in value && isString(value.iban))) return false;
  if (!('accountType' in value && isBankAccountType(value.accountType))) return false;
  if (!('type' in value && isContactType(value.type))) return false;

  return true;
};

export const isSwiftUserInfoOrNull = (value: unknown): value is SwiftUserInfo | null => {
  return value === null || isSwiftUserInfo(value);
};

export const isArrayOfSwiftUserInfo = (value: unknown): value is readonly SwiftUserInfo[] => {
  return Array.isArray(value) && value.every(isSwiftUserInfo);
};

export const isArrayOfSwiftUserInfoOrNull = (
  value: unknown,
): value is readonly SwiftUserInfo[] | null => {
  return value === null || isArrayOfSwiftUserInfo(value);
};

const propertiesOfSwiftUserInfo: readonly string[] = [
  'name',
  'street1',
  'postalCode',
  'city',
  'state',
  'country',
  'routingKey',
  'iban',
  'accountType',
  'type',
];

export const isKeyOfSwiftUserInfo = (value: unknown): value is keyof SwiftUserInfo => {
  return typeof value === 'string' && propertiesOfSwiftUserInfo.includes(value);
};

export const isSwiftBusinessInfo = (value: unknown): value is SwiftBusinessInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('address' in value && isString(value.address))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('registrationNumber' in value && isStringOrNull(value.registrationNumber))) return false;
  if (!('accountNumber' in value && isString(value.accountNumber))) return false;
  if (!('accountType' in value && isBankAccountType(value.accountType))) return false;
  if (!('routingNumber' in value && isString(value.routingNumber))) return false;
  if ('phoneNumber' in value && !isStringOrNull(value.phoneNumber)) return false;
  if ('registrationType' in value && !isStringOrNull(value.registrationType)) return false;
  if ('registrationDate' in value && !isStringOrNull(value.registrationDate)) return false;
  if ('registrationExpiryDate' in value && !isStringOrNull(value.registrationExpiryDate))
    return false;
  if ('mobileNumber' in value && !isStringOrNull(value.mobileNumber)) return false;
  if ('businessNature' in value && !isStringOrNull(value.businessNature)) return false;
  if ('email' in value && !isStringOrNull(value.email)) return false;

  return true;
};

export const isSwiftBusinessInfoOrNull = (value: unknown): value is SwiftBusinessInfo | null => {
  return value === null || isSwiftBusinessInfo(value);
};

export const isArrayOfSwiftBusinessInfo = (
  value: unknown,
): value is readonly SwiftBusinessInfo[] => {
  return Array.isArray(value) && value.every(isSwiftBusinessInfo);
};

export const isArrayOfSwiftBusinessInfoOrNull = (
  value: unknown,
): value is readonly SwiftBusinessInfo[] | null => {
  return value === null || isArrayOfSwiftBusinessInfo(value);
};

const propertiesOfSwiftBusinessInfo: readonly string[] = [
  'name',
  'address',
  'city',
  'state',
  'country',
  'postalCode',
  'registrationNumber',
  'accountNumber',
  'accountType',
  'routingNumber',
  'phoneNumber',
  'registrationType',
  'registrationDate',
  'registrationExpiryDate',
  'mobileNumber',
  'businessNature',
  'email',
];

export const isKeyOfSwiftBusinessInfo = (value: unknown): value is keyof SwiftBusinessInfo => {
  return typeof value === 'string' && propertiesOfSwiftBusinessInfo.includes(value);
};

export const isSwiftBankInfo = (value: unknown): value is SwiftBankInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('swiftCode' in value && isString(value.swiftCode))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('street1' in value && isString(value.street1))) return false;
  if (!('street2' in value && isString(value.street2))) return false;
  if (!('postalCode' in value && isString(value.postalCode))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('country' in value && isString(value.country))) return false;

  return true;
};

export const isSwiftBankInfoOrNull = (value: unknown): value is SwiftBankInfo | null => {
  return value === null || isSwiftBankInfo(value);
};

export const isArrayOfSwiftBankInfo = (value: unknown): value is readonly SwiftBankInfo[] => {
  return Array.isArray(value) && value.every(isSwiftBankInfo);
};

export const isArrayOfSwiftBankInfoOrNull = (
  value: unknown,
): value is readonly SwiftBankInfo[] | null => {
  return value === null || isArrayOfSwiftBankInfo(value);
};

const propertiesOfSwiftBankInfo: readonly string[] = [
  'swiftCode',
  'name',
  'street1',
  'street2',
  'postalCode',
  'city',
  'state',
  'country',
];

export const isKeyOfSwiftBankInfo = (value: unknown): value is keyof SwiftBankInfo => {
  return typeof value === 'string' && propertiesOfSwiftBankInfo.includes(value);
};

export const isSwiftAccount = (value: unknown): value is SwiftAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('personInfo' in value && isSwiftUserInfoOrNull(value.personInfo))) return false;
  if (!('businessInfo' in value && isSwiftBusinessInfoOrNull(value.businessInfo))) return false;
  if (!('bankInfo' in value && isSwiftBankInfo(value.bankInfo))) return false;
  if (!('isPobo' in value && isBooleanOrNull(value.isPobo))) return false;

  return true;
};

export const isSwiftAccountOrNull = (value: unknown): value is SwiftAccount | null => {
  return value === null || isSwiftAccount(value);
};

export const isArrayOfSwiftAccount = (value: unknown): value is readonly SwiftAccount[] => {
  return Array.isArray(value) && value.every(isSwiftAccount);
};

export const isArrayOfSwiftAccountOrNull = (
  value: unknown,
): value is readonly SwiftAccount[] | null => {
  return value === null || isArrayOfSwiftAccount(value);
};

const propertiesOfSwiftAccount: readonly string[] = [
  'personInfo',
  'businessInfo',
  'bankInfo',
  'isPobo',
];

export const isKeyOfSwiftAccount = (value: unknown): value is keyof SwiftAccount => {
  return typeof value === 'string' && propertiesOfSwiftAccount.includes(value);
};

export const isPixAccount = (value: unknown): value is PixAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('pixKey' in value && isString(value.pixKey))) return false;

  return true;
};

export const isPixAccountOrNull = (value: unknown): value is PixAccount | null => {
  return value === null || isPixAccount(value);
};

export const isArrayOfPixAccount = (value: unknown): value is readonly PixAccount[] => {
  return Array.isArray(value) && value.every(isPixAccount);
};

export const isArrayOfPixAccountOrNull = (
  value: unknown,
): value is readonly PixAccount[] | null => {
  return value === null || isArrayOfPixAccount(value);
};

const propertiesOfPixAccount: readonly string[] = ['pixKey'];

export const isKeyOfPixAccount = (value: unknown): value is keyof PixAccount => {
  return typeof value === 'string' && propertiesOfPixAccount.includes(value);
};

export const isSpeiAccount = (value: unknown): value is SpeiAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('clabe' in value && isString(value.clabe))) return false;
  if (!('bankCode' in value && isString(value.bankCode))) return false;
  if (!('receiverName' in value && isString(value.receiverName))) return false;

  return true;
};

export const isSpeiAccountOrNull = (value: unknown): value is SpeiAccount | null => {
  return value === null || isSpeiAccount(value);
};

export const isArrayOfSpeiAccount = (value: unknown): value is readonly SpeiAccount[] => {
  return Array.isArray(value) && value.every(isSpeiAccount);
};

export const isArrayOfSpeiAccountOrNull = (
  value: unknown,
): value is readonly SpeiAccount[] | null => {
  return value === null || isArrayOfSpeiAccount(value);
};

const propertiesOfSpeiAccount: readonly string[] = ['clabe', 'bankCode', 'receiverName'];

export const isKeyOfSpeiAccount = (value: unknown): value is keyof SpeiAccount => {
  return typeof value === 'string' && propertiesOfSpeiAccount.includes(value);
};

export const isCOPAccount = (value: unknown): value is COPAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if ('lastName' in value && !isStringOrNull(value.lastName)) return false;
  if (!('documentType' in value && isCopDocumentTypeOrNull(value.documentType))) return false;
  if (!('accountType' in value && isNumber(value.accountType))) return false;
  if (!('bankAccount' in value && isString(value.bankAccount))) return false;
  if (!('bankCode' in value && isString(value.bankCode))) return false;
  if (!('thirdPartyWithdrawal' in value && isBooleanOrNull(value.thirdPartyWithdrawal)))
    return false;
  if (!('documentId' in value && isStringOrNull(value.documentId))) return false;
  if (!('email' in value && isStringOrNull(value.email))) return false;

  return true;
};

export const isCOPAccountOrNull = (value: unknown): value is COPAccount | null => {
  return value === null || isCOPAccount(value);
};

export const isArrayOfCOPAccount = (value: unknown): value is readonly COPAccount[] => {
  return Array.isArray(value) && value.every(isCOPAccount);
};

export const isArrayOfCOPAccountOrNull = (
  value: unknown,
): value is readonly COPAccount[] | null => {
  return value === null || isArrayOfCOPAccount(value);
};

const propertiesOfCOPAccount: readonly string[] = [
  'firstName',
  'lastName',
  'documentType',
  'accountType',
  'bankAccount',
  'bankCode',
  'thirdPartyWithdrawal',
  'documentId',
  'email',
];

export const isKeyOfCOPAccount = (value: unknown): value is keyof COPAccount => {
  return typeof value === 'string' && propertiesOfCOPAccount.includes(value);
};

export const isCVUAccount = (value: unknown): value is CVUAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('cvu' in value && isString(value.cvu))) return false;
  if (!('recipientName' in value && isString(value.recipientName))) return false;

  return true;
};

export const isCVUAccountOrNull = (value: unknown): value is CVUAccount | null => {
  return value === null || isCVUAccount(value);
};

export const isArrayOfCVUAccount = (value: unknown): value is readonly CVUAccount[] => {
  return Array.isArray(value) && value.every(isCVUAccount);
};

export const isArrayOfCVUAccountOrNull = (
  value: unknown,
): value is readonly CVUAccount[] | null => {
  return value === null || isArrayOfCVUAccount(value);
};

const propertiesOfCVUAccount: readonly string[] = ['cvu', 'recipientName'];

export const isKeyOfCVUAccount = (value: unknown): value is keyof CVUAccount => {
  return typeof value === 'string' && propertiesOfCVUAccount.includes(value);
};

export const isWireAccountDetails = (value: unknown): value is WireAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('wireDetails' in value && isWireAccount(value.wireDetails))) return false;

  return true;
};

export const isWireAccountDetailsOrNull = (value: unknown): value is WireAccountDetails | null => {
  return value === null || isWireAccountDetails(value);
};

export const isArrayOfWireAccountDetails = (
  value: unknown,
): value is readonly WireAccountDetails[] => {
  return Array.isArray(value) && value.every(isWireAccountDetails);
};

export const isArrayOfWireAccountDetailsOrNull = (
  value: unknown,
): value is readonly WireAccountDetails[] | null => {
  return value === null || isArrayOfWireAccountDetails(value);
};

const propertiesOfWireAccountDetails: readonly string[] = ['wireDetails'];

export const isKeyOfWireAccountDetails = (value: unknown): value is keyof WireAccountDetails => {
  return typeof value === 'string' && propertiesOfWireAccountDetails.includes(value);
};

export const isACHAccountDetails = (value: unknown): value is ACHAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('achDetails' in value && isACHAccount(value.achDetails))) return false;

  return true;
};

export const isACHAccountDetailsOrNull = (value: unknown): value is ACHAccountDetails | null => {
  return value === null || isACHAccountDetails(value);
};

export const isArrayOfACHAccountDetails = (
  value: unknown,
): value is readonly ACHAccountDetails[] => {
  return Array.isArray(value) && value.every(isACHAccountDetails);
};

export const isArrayOfACHAccountDetailsOrNull = (
  value: unknown,
): value is readonly ACHAccountDetails[] | null => {
  return value === null || isArrayOfACHAccountDetails(value);
};

const propertiesOfACHAccountDetails: readonly string[] = ['achDetails'];

export const isKeyOfACHAccountDetails = (value: unknown): value is keyof ACHAccountDetails => {
  return typeof value === 'string' && propertiesOfACHAccountDetails.includes(value);
};

export const isSwiftAccountDetails = (value: unknown): value is SwiftAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('swiftDetails' in value && isSwiftAccount(value.swiftDetails))) return false;

  return true;
};

export const isSwiftAccountDetailsOrNull = (
  value: unknown,
): value is SwiftAccountDetails | null => {
  return value === null || isSwiftAccountDetails(value);
};

export const isArrayOfSwiftAccountDetails = (
  value: unknown,
): value is readonly SwiftAccountDetails[] => {
  return Array.isArray(value) && value.every(isSwiftAccountDetails);
};

export const isArrayOfSwiftAccountDetailsOrNull = (
  value: unknown,
): value is readonly SwiftAccountDetails[] | null => {
  return value === null || isArrayOfSwiftAccountDetails(value);
};

const propertiesOfSwiftAccountDetails: readonly string[] = ['swiftDetails'];

export const isKeyOfSwiftAccountDetails = (value: unknown): value is keyof SwiftAccountDetails => {
  return typeof value === 'string' && propertiesOfSwiftAccountDetails.includes(value);
};

export const isPIXAccountDetails = (value: unknown): value is PIXAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('pixDetails' in value && isPixAccount(value.pixDetails))) return false;

  return true;
};

export const isPIXAccountDetailsOrNull = (value: unknown): value is PIXAccountDetails | null => {
  return value === null || isPIXAccountDetails(value);
};

export const isArrayOfPIXAccountDetails = (
  value: unknown,
): value is readonly PIXAccountDetails[] => {
  return Array.isArray(value) && value.every(isPIXAccountDetails);
};

export const isArrayOfPIXAccountDetailsOrNull = (
  value: unknown,
): value is readonly PIXAccountDetails[] | null => {
  return value === null || isArrayOfPIXAccountDetails(value);
};

const propertiesOfPIXAccountDetails: readonly string[] = ['pixDetails'];

export const isKeyOfPIXAccountDetails = (value: unknown): value is keyof PIXAccountDetails => {
  return typeof value === 'string' && propertiesOfPIXAccountDetails.includes(value);
};

export const isCOPAccountDetails = (value: unknown): value is COPAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('copDetails' in value && isCOPAccount(value.copDetails))) return false;

  return true;
};

export const isCOPAccountDetailsOrNull = (value: unknown): value is COPAccountDetails | null => {
  return value === null || isCOPAccountDetails(value);
};

export const isArrayOfCOPAccountDetails = (
  value: unknown,
): value is readonly COPAccountDetails[] => {
  return Array.isArray(value) && value.every(isCOPAccountDetails);
};

export const isArrayOfCOPAccountDetailsOrNull = (
  value: unknown,
): value is readonly COPAccountDetails[] | null => {
  return value === null || isArrayOfCOPAccountDetails(value);
};

const propertiesOfCOPAccountDetails: readonly string[] = ['copDetails'];

export const isKeyOfCOPAccountDetails = (value: unknown): value is keyof COPAccountDetails => {
  return typeof value === 'string' && propertiesOfCOPAccountDetails.includes(value);
};

export const isSpeiAccountDetails = (value: unknown): value is SpeiAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('speiDetails' in value && isSpeiAccount(value.speiDetails))) return false;

  return true;
};

export const isSpeiAccountDetailsOrNull = (value: unknown): value is SpeiAccountDetails | null => {
  return value === null || isSpeiAccountDetails(value);
};

export const isArrayOfSpeiAccountDetails = (
  value: unknown,
): value is readonly SpeiAccountDetails[] => {
  return Array.isArray(value) && value.every(isSpeiAccountDetails);
};

export const isArrayOfSpeiAccountDetailsOrNull = (
  value: unknown,
): value is readonly SpeiAccountDetails[] | null => {
  return value === null || isArrayOfSpeiAccountDetails(value);
};

const propertiesOfSpeiAccountDetails: readonly string[] = ['speiDetails'];

export const isKeyOfSpeiAccountDetails = (value: unknown): value is keyof SpeiAccountDetails => {
  return typeof value === 'string' && propertiesOfSpeiAccountDetails.includes(value);
};

export const isCVUAccountDetails = (value: unknown): value is CVUAccountDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('cvuDetails' in value && isCVUAccount(value.cvuDetails))) return false;

  return true;
};

export const isCVUAccountDetailsOrNull = (value: unknown): value is CVUAccountDetails | null => {
  return value === null || isCVUAccountDetails(value);
};

export const isArrayOfCVUAccountDetails = (
  value: unknown,
): value is readonly CVUAccountDetails[] => {
  return Array.isArray(value) && value.every(isCVUAccountDetails);
};

export const isArrayOfCVUAccountDetailsOrNull = (
  value: unknown,
): value is readonly CVUAccountDetails[] | null => {
  return value === null || isArrayOfCVUAccountDetails(value);
};

const propertiesOfCVUAccountDetails: readonly string[] = ['cvuDetails'];

export const isKeyOfCVUAccountDetails = (value: unknown): value is keyof CVUAccountDetails => {
  return typeof value === 'string' && propertiesOfCVUAccountDetails.includes(value);
};

export const isCreateFiatAccountResponse = (value: unknown): value is CreateFiatAccountResponse => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('beneficiaryId' in value && isString(value.beneficiaryId))) return false;
  if (!('belongsToBeneficiary' in value && isBoolean(value.belongsToBeneficiary))) return false;
  if (!('fiatAccountType' in value && isFiatAccountType(value.fiatAccountType))) return false;
  if (!('accountDetails' in value && isAccountDetails(value.accountDetails))) return false;

  return true;
};

export const isCreateFiatAccountResponseOrNull = (
  value: unknown,
): value is CreateFiatAccountResponse | null => {
  return value === null || isCreateFiatAccountResponse(value);
};

export const isArrayOfCreateFiatAccountResponse = (
  value: unknown,
): value is readonly CreateFiatAccountResponse[] => {
  return Array.isArray(value) && value.every(isCreateFiatAccountResponse);
};

export const isArrayOfCreateFiatAccountResponseOrNull = (
  value: unknown,
): value is readonly CreateFiatAccountResponse[] | null => {
  return value === null || isArrayOfCreateFiatAccountResponse(value);
};

const propertiesOfCreateFiatAccountResponse: readonly string[] = [
  'id',
  'name',
  'beneficiaryId',
  'belongsToBeneficiary',
  'fiatAccountType',
  'accountDetails',
];

export const isKeyOfCreateFiatAccountResponse = (
  value: unknown,
): value is keyof CreateFiatAccountResponse => {
  return typeof value === 'string' && propertiesOfCreateFiatAccountResponse.includes(value);
};

export const isCreateFiatAccountRequest = (value: unknown): value is CreateFiatAccountRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('beneficiaryId' in value && isString(value.beneficiaryId))) return false;
  if (!('belongsToBeneficiary' in value && isBoolean(value.belongsToBeneficiary))) return false;
  if (!('fiatAccountType' in value && isFiatAccountType(value.fiatAccountType))) return false;
  if (!('accountDetails' in value && isAccountDetails(value.accountDetails))) return false;
  if (!('contactId' in value && isStringOrNull(value.contactId))) return false;
  if ('nickname' in value && !isStringOrNull(value.nickname)) return false;

  return true;
};

export const isCreateFiatAccountRequestOrNull = (
  value: unknown,
): value is CreateFiatAccountRequest | null => {
  return value === null || isCreateFiatAccountRequest(value);
};

export const isArrayOfCreateFiatAccountRequest = (
  value: unknown,
): value is readonly CreateFiatAccountRequest[] => {
  return Array.isArray(value) && value.every(isCreateFiatAccountRequest);
};

export const isArrayOfCreateFiatAccountRequestOrNull = (
  value: unknown,
): value is readonly CreateFiatAccountRequest[] | null => {
  return value === null || isArrayOfCreateFiatAccountRequest(value);
};

const propertiesOfCreateFiatAccountRequest: readonly string[] = [
  'name',
  'beneficiaryId',
  'belongsToBeneficiary',
  'fiatAccountType',
  'accountDetails',
  'contactId',
  'nickname',
];

export const isKeyOfCreateFiatAccountRequest = (
  value: unknown,
): value is keyof CreateFiatAccountRequest => {
  return typeof value === 'string' && propertiesOfCreateFiatAccountRequest.includes(value);
};

export const isUpdateFiatAccountRequestData = (
  value: unknown,
): value is UpdateFiatAccountRequestData => {
  if (value === null || typeof value !== 'object') return false;
  if ('name' in value && !isString(value.name)) return false;
  if ('nickname' in value && !isStringOrNull(value.nickname)) return false;

  return true;
};

export const isUpdateFiatAccountRequestDataOrNull = (
  value: unknown,
): value is UpdateFiatAccountRequestData | null => {
  return value === null || isUpdateFiatAccountRequestData(value);
};

export const isArrayOfUpdateFiatAccountRequestData = (
  value: unknown,
): value is readonly UpdateFiatAccountRequestData[] => {
  return Array.isArray(value) && value.every(isUpdateFiatAccountRequestData);
};

export const isArrayOfUpdateFiatAccountRequestDataOrNull = (
  value: unknown,
): value is readonly UpdateFiatAccountRequestData[] | null => {
  return value === null || isArrayOfUpdateFiatAccountRequestData(value);
};

const propertiesOfUpdateFiatAccountRequestData: readonly string[] = ['name', 'nickname'];

export const isKeyOfUpdateFiatAccountRequestData = (
  value: unknown,
): value is keyof UpdateFiatAccountRequestData => {
  return typeof value === 'string' && propertiesOfUpdateFiatAccountRequestData.includes(value);
};

export const isUpdateFiatAccountRequest = (value: unknown): value is UpdateFiatAccountRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('data' in value && isUpdateFiatAccountRequestData(value.data))) return false;

  return true;
};

export const isUpdateFiatAccountRequestOrNull = (
  value: unknown,
): value is UpdateFiatAccountRequest | null => {
  return value === null || isUpdateFiatAccountRequest(value);
};

export const isArrayOfUpdateFiatAccountRequest = (
  value: unknown,
): value is readonly UpdateFiatAccountRequest[] => {
  return Array.isArray(value) && value.every(isUpdateFiatAccountRequest);
};

export const isArrayOfUpdateFiatAccountRequestOrNull = (
  value: unknown,
): value is readonly UpdateFiatAccountRequest[] | null => {
  return value === null || isArrayOfUpdateFiatAccountRequest(value);
};

const propertiesOfUpdateFiatAccountRequest: readonly string[] = ['id', 'data'];

export const isKeyOfUpdateFiatAccountRequest = (
  value: unknown,
): value is keyof UpdateFiatAccountRequest => {
  return typeof value === 'string' && propertiesOfUpdateFiatAccountRequest.includes(value);
};

export const isRecipientAccount = (value: unknown): value is RecipientAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('bankName' in value && isStringOrNull(value.bankName))) return false;
  if (!('accountNumber' in value && isStringOrNull(value.accountNumber))) return false;
  if (!('paymentMethod' in value && isString(value.paymentMethod))) return false;
  if (!('currency' in value && isString(value.currency))) return false;
  if (!('currencyCode' in value && isCurrencyCodeType(value.currencyCode))) return false;
  if (!('nickname' in value && isStringOrNull(value.nickname))) return false;

  return true;
};

export const isRecipientAccountOrNull = (value: unknown): value is RecipientAccount | null => {
  return value === null || isRecipientAccount(value);
};

export const isArrayOfRecipientAccount = (value: unknown): value is readonly RecipientAccount[] => {
  return Array.isArray(value) && value.every(isRecipientAccount);
};

export const isArrayOfRecipientAccountOrNull = (
  value: unknown,
): value is readonly RecipientAccount[] | null => {
  return value === null || isArrayOfRecipientAccount(value);
};

const propertiesOfRecipientAccount: readonly string[] = [
  'id',
  'name',
  'bankName',
  'accountNumber',
  'paymentMethod',
  'currency',
  'currencyCode',
  'nickname',
];

export const isKeyOfRecipientAccount = (value: unknown): value is keyof RecipientAccount => {
  return typeof value === 'string' && propertiesOfRecipientAccount.includes(value);
};

export const isCreateContactRequest = (value: unknown): value is CreateContactRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('beneficiaryId' in value && isString(value.beneficiaryId))) return false;
  if (!('entity' in value && isContactData(value.entity))) return false;
  if (!('country' in value && isCountryType(value.country))) return false;
  if (!('address' in value && isContactAddress(value.address))) return false;
  if (!('belongsToBeneficiary' in value && isBoolean(value.belongsToBeneficiary))) return false;

  return true;
};

export const isCreateContactRequestOrNull = (
  value: unknown,
): value is CreateContactRequest | null => {
  return value === null || isCreateContactRequest(value);
};

export const isArrayOfCreateContactRequest = (
  value: unknown,
): value is readonly CreateContactRequest[] => {
  return Array.isArray(value) && value.every(isCreateContactRequest);
};

export const isArrayOfCreateContactRequestOrNull = (
  value: unknown,
): value is readonly CreateContactRequest[] | null => {
  return value === null || isArrayOfCreateContactRequest(value);
};

const propertiesOfCreateContactRequest: readonly string[] = [
  'beneficiaryId',
  'entity',
  'country',
  'address',
  'belongsToBeneficiary',
];

export const isKeyOfCreateContactRequest = (
  value: unknown,
): value is keyof CreateContactRequest => {
  return typeof value === 'string' && propertiesOfCreateContactRequest.includes(value);
};

export const isUpdateContactRequestData = (value: unknown): value is UpdateContactRequestData => {
  if (value === null || typeof value !== 'object') return false;
  if (!('businessRelationship' in value && isBusinessRelationshipType(value.businessRelationship)))
    return false;

  return true;
};

export const isUpdateContactRequestDataOrNull = (
  value: unknown,
): value is UpdateContactRequestData | null => {
  return value === null || isUpdateContactRequestData(value);
};

export const isArrayOfUpdateContactRequestData = (
  value: unknown,
): value is readonly UpdateContactRequestData[] => {
  return Array.isArray(value) && value.every(isUpdateContactRequestData);
};

export const isArrayOfUpdateContactRequestDataOrNull = (
  value: unknown,
): value is readonly UpdateContactRequestData[] | null => {
  return value === null || isArrayOfUpdateContactRequestData(value);
};

const propertiesOfUpdateContactRequestData: readonly string[] = ['businessRelationship'];

export const isKeyOfUpdateContactRequestData = (
  value: unknown,
): value is keyof UpdateContactRequestData => {
  return typeof value === 'string' && propertiesOfUpdateContactRequestData.includes(value);
};

export const isUpdateContactRequest = (value: unknown): value is UpdateContactRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('data' in value && isUpdateContactRequestData(value.data))) return false;

  return true;
};

export const isUpdateContactRequestOrNull = (
  value: unknown,
): value is UpdateContactRequest | null => {
  return value === null || isUpdateContactRequest(value);
};

export const isArrayOfUpdateContactRequest = (
  value: unknown,
): value is readonly UpdateContactRequest[] => {
  return Array.isArray(value) && value.every(isUpdateContactRequest);
};

export const isArrayOfUpdateContactRequestOrNull = (
  value: unknown,
): value is readonly UpdateContactRequest[] | null => {
  return value === null || isArrayOfUpdateContactRequest(value);
};

const propertiesOfUpdateContactRequest: readonly string[] = ['id', 'data'];

export const isKeyOfUpdateContactRequest = (
  value: unknown,
): value is keyof UpdateContactRequest => {
  return typeof value === 'string' && propertiesOfUpdateContactRequest.includes(value);
};

export const isCryptoAccount = (value: unknown): value is CryptoAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('currency' in value && isCryptoCurrencyCodeType(value.currency))) return false;
  if (!('chain' in value && isString(value.chain))) return false;
  if (!('walletAddress' in value && isString(value.walletAddress))) return false;

  return true;
};

export const isCryptoAccountOrNull = (value: unknown): value is CryptoAccount | null => {
  return value === null || isCryptoAccount(value);
};

export const isArrayOfCryptoAccount = (value: unknown): value is readonly CryptoAccount[] => {
  return Array.isArray(value) && value.every(isCryptoAccount);
};

export const isArrayOfCryptoAccountOrNull = (
  value: unknown,
): value is readonly CryptoAccount[] | null => {
  return value === null || isArrayOfCryptoAccount(value);
};

const propertiesOfCryptoAccount: readonly string[] = [
  'id',
  'name',
  'currency',
  'chain',
  'walletAddress',
];

export const isKeyOfCryptoAccount = (value: unknown): value is keyof CryptoAccount => {
  return typeof value === 'string' && propertiesOfCryptoAccount.includes(value);
};

export const isFiatAccount = (value: unknown): value is FiatAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('beneficiaryId' in value && isString(value.beneficiaryId))) return false;
  if (!('belongsToBeneficiary' in value && isBoolean(value.belongsToBeneficiary))) return false;
  if (!('fiatAccountType' in value && isFiatAccountType(value.fiatAccountType))) return false;
  if (!('accountDetails' in value && isAccountDetails(value.accountDetails))) return false;
  if (!('nickname' in value && isStringOrNull(value.nickname))) return false;

  return true;
};

export const isFiatAccountOrNull = (value: unknown): value is FiatAccount | null => {
  return value === null || isFiatAccount(value);
};

export const isArrayOfFiatAccount = (value: unknown): value is readonly FiatAccount[] => {
  return Array.isArray(value) && value.every(isFiatAccount);
};

export const isArrayOfFiatAccountOrNull = (
  value: unknown,
): value is readonly FiatAccount[] | null => {
  return value === null || isArrayOfFiatAccount(value);
};

const propertiesOfFiatAccount: readonly string[] = [
  'id',
  'name',
  'beneficiaryId',
  'belongsToBeneficiary',
  'fiatAccountType',
  'accountDetails',
  'nickname',
];

export const isKeyOfFiatAccount = (value: unknown): value is keyof FiatAccount => {
  return typeof value === 'string' && propertiesOfFiatAccount.includes(value);
};

export const isSimplifiedAccount = (value: unknown): value is SimplifiedAccount => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('currency' in value && isString(value.currency))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if ('bankName' in value && !isString(value.bankName)) return false;
  if (!('country' in value && isCountryType(value.country))) return false;

  return true;
};

export const isSimplifiedAccountOrNull = (value: unknown): value is SimplifiedAccount | null => {
  return value === null || isSimplifiedAccount(value);
};

export const isArrayOfSimplifiedAccount = (
  value: unknown,
): value is readonly SimplifiedAccount[] => {
  return Array.isArray(value) && value.every(isSimplifiedAccount);
};

export const isArrayOfSimplifiedAccountOrNull = (
  value: unknown,
): value is readonly SimplifiedAccount[] | null => {
  return value === null || isArrayOfSimplifiedAccount(value);
};

const propertiesOfSimplifiedAccount: readonly string[] = [
  'id',
  'currency',
  'name',
  'bankName',
  'country',
];

export const isKeyOfSimplifiedAccount = (value: unknown): value is keyof SimplifiedAccount => {
  return typeof value === 'string' && propertiesOfSimplifiedAccount.includes(value);
};

export const isContactBase = (value: unknown): value is ContactBase => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isStringOrNull(value.id))) return false;
  if (!('entity' in value && isContactData(value.entity))) return false;
  if (!('country' in value && isCountryType(value.country))) return false;
  if (!('address' in value && isContactAddress(value.address))) return false;

  return true;
};

export const isContactBaseOrNull = (value: unknown): value is ContactBase | null => {
  return value === null || isContactBase(value);
};

export const isArrayOfContactBase = (value: unknown): value is readonly ContactBase[] => {
  return Array.isArray(value) && value.every(isContactBase);
};

export const isArrayOfContactBaseOrNull = (
  value: unknown,
): value is readonly ContactBase[] | null => {
  return value === null || isArrayOfContactBase(value);
};

const propertiesOfContactBase: readonly string[] = ['id', 'entity', 'country', 'address'];

export const isKeyOfContactBase = (value: unknown): value is keyof ContactBase => {
  return typeof value === 'string' && propertiesOfContactBase.includes(value);
};

export const isContact = (value: unknown): value is Contact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('accounts' in value && isArrayOfFiatAccount(value.accounts))) return false;
  if (!('recipients' in value && isArrayOfRecipientResponse(value.recipients))) return false;
  if (!('belongsToBeneficiary' in value && isBoolean(value.belongsToBeneficiary))) return false;

  return true;
};

export const isContactOrNull = (value: unknown): value is Contact | null => {
  return value === null || isContact(value);
};

export const isArrayOfContact = (value: unknown): value is readonly Contact[] => {
  return Array.isArray(value) && value.every(isContact);
};

export const isArrayOfContactOrNull = (value: unknown): value is readonly Contact[] | null => {
  return value === null || isArrayOfContact(value);
};

const propertiesOfContact: readonly string[] = [
  'id',
  'accounts',
  'recipients',
  'belongsToBeneficiary',
];

export const isKeyOfContact = (value: unknown): value is keyof Contact => {
  return typeof value === 'string' && propertiesOfContact.includes(value);
};

export const isSelfContact = (value: unknown): value is SelfContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isNull(value.id))) return false;

  return true;
};

export const isSelfContactOrNull = (value: unknown): value is SelfContact | null => {
  return value === null || isSelfContact(value);
};

export const isArrayOfSelfContact = (value: unknown): value is readonly SelfContact[] => {
  return Array.isArray(value) && value.every(isSelfContact);
};

export const isArrayOfSelfContactOrNull = (
  value: unknown,
): value is readonly SelfContact[] | null => {
  return value === null || isArrayOfSelfContact(value);
};

const propertiesOfSelfContact: readonly string[] = ['id'];

export const isKeyOfSelfContact = (value: unknown): value is keyof SelfContact => {
  return typeof value === 'string' && propertiesOfSelfContact.includes(value);
};

export const isSearchableContact = (value: unknown): value is SearchableContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('displayName' in value && isString(value.displayName))) return false;

  return true;
};

export const isSearchableContactOrNull = (value: unknown): value is SearchableContact | null => {
  return value === null || isSearchableContact(value);
};

export const isArrayOfSearchableContact = (
  value: unknown,
): value is readonly SearchableContact[] => {
  return Array.isArray(value) && value.every(isSearchableContact);
};

export const isArrayOfSearchableContactOrNull = (
  value: unknown,
): value is readonly SearchableContact[] | null => {
  return value === null || isArrayOfSearchableContact(value);
};

const propertiesOfSearchableContact: readonly string[] = ['id', 'displayName'];

export const isKeyOfSearchableContact = (value: unknown): value is keyof SearchableContact => {
  return typeof value === 'string' && propertiesOfSearchableContact.includes(value);
};

export const isPaymentMethodBase = (value: unknown): value is PaymentMethodBase => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && isPaymentMethodAccountType(value.type))) return false;

  return true;
};

export const isPaymentMethodBaseOrNull = (value: unknown): value is PaymentMethodBase | null => {
  return value === null || isPaymentMethodBase(value);
};

export const isArrayOfPaymentMethodBase = (
  value: unknown,
): value is readonly PaymentMethodBase[] => {
  return Array.isArray(value) && value.every(isPaymentMethodBase);
};

export const isArrayOfPaymentMethodBaseOrNull = (
  value: unknown,
): value is readonly PaymentMethodBase[] | null => {
  return value === null || isArrayOfPaymentMethodBase(value);
};

const propertiesOfPaymentMethodBase: readonly string[] = ['type'];

export const isKeyOfPaymentMethodBase = (value: unknown): value is keyof PaymentMethodBase => {
  return typeof value === 'string' && propertiesOfPaymentMethodBase.includes(value);
};

export const isFiatPaymentACHWireFormBase = (
  value: unknown,
): value is FiatPaymentACHWireFormBase => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === PaymentMethodAccountType.fiat)) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('country' in value && value.country === CountryType.US)) return false;
  if (!('currency' in value && isString(value.currency))) return false;
  if (!('paymentMethod' in value && isFiatAccountType(value.paymentMethod))) return false;
  if (!('bankName' in value && isString(value.bankName))) return false;
  if (!('address' in value && isContactAddress(value.address))) return false;
  if (!('routingNumber' in value && isString(value.routingNumber))) return false;
  if (!('accountNumber' in value && isString(value.accountNumber))) return false;

  return true;
};

export const isFiatPaymentACHWireFormBaseOrNull = (
  value: unknown,
): value is FiatPaymentACHWireFormBase | null => {
  return value === null || isFiatPaymentACHWireFormBase(value);
};

export const isArrayOfFiatPaymentACHWireFormBase = (
  value: unknown,
): value is readonly FiatPaymentACHWireFormBase[] => {
  return Array.isArray(value) && value.every(isFiatPaymentACHWireFormBase);
};

export const isArrayOfFiatPaymentACHWireFormBaseOrNull = (
  value: unknown,
): value is readonly FiatPaymentACHWireFormBase[] | null => {
  return value === null || isArrayOfFiatPaymentACHWireFormBase(value);
};

const propertiesOfFiatPaymentACHWireFormBase: readonly string[] = [
  'type',
  'name',
  'country',
  'currency',
  'paymentMethod',
  'bankName',
  'address',
  'routingNumber',
  'accountNumber',
];

export const isKeyOfFiatPaymentACHWireFormBase = (
  value: unknown,
): value is keyof FiatPaymentACHWireFormBase => {
  return typeof value === 'string' && propertiesOfFiatPaymentACHWireFormBase.includes(value);
};

export const isCryptoPaymentForm = (value: unknown): value is CryptoPaymentForm => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === PaymentMethodAccountType.crypto)) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('country' in value && isCountryType(value.country))) return false;
  if (!('currency' in value && isString(value.currency))) return false;
  if (!('assetType' in value && isCryptoAssetType(value.assetType))) return false;
  if (!('chain' in value && isCryptoChain(value.chain))) return false;
  if (!('walletAddress' in value && isString(value.walletAddress))) return false;
  if (!('destination' in value && isString(value.destination))) return false;

  return true;
};

export const isCryptoPaymentFormOrNull = (value: unknown): value is CryptoPaymentForm | null => {
  return value === null || isCryptoPaymentForm(value);
};

export const isArrayOfCryptoPaymentForm = (
  value: unknown,
): value is readonly CryptoPaymentForm[] => {
  return Array.isArray(value) && value.every(isCryptoPaymentForm);
};

export const isArrayOfCryptoPaymentFormOrNull = (
  value: unknown,
): value is readonly CryptoPaymentForm[] | null => {
  return value === null || isArrayOfCryptoPaymentForm(value);
};

const propertiesOfCryptoPaymentForm: readonly string[] = [
  'type',
  'name',
  'country',
  'currency',
  'assetType',
  'chain',
  'walletAddress',
  'destination',
];

export const isKeyOfCryptoPaymentForm = (value: unknown): value is keyof CryptoPaymentForm => {
  return typeof value === 'string' && propertiesOfCryptoPaymentForm.includes(value);
};

export const isContactFormBase = (value: unknown): value is ContactFormBase => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && isContactType(value.type))) return false;
  if (!('country' in value && isCountryType(value.country))) return false;
  if (!('address' in value && isContactAddress(value.address))) return false;
  if (!('businessRelationship' in value && isBusinessRelationshipType(value.businessRelationship)))
    return false;

  return true;
};

export const isContactFormBaseOrNull = (value: unknown): value is ContactFormBase | null => {
  return value === null || isContactFormBase(value);
};

export const isArrayOfContactFormBase = (value: unknown): value is readonly ContactFormBase[] => {
  return Array.isArray(value) && value.every(isContactFormBase);
};

export const isArrayOfContactFormBaseOrNull = (
  value: unknown,
): value is readonly ContactFormBase[] | null => {
  return value === null || isArrayOfContactFormBase(value);
};

const propertiesOfContactFormBase: readonly string[] = [
  'type',
  'country',
  'address',
  'businessRelationship',
];

export const isKeyOfContactFormBase = (value: unknown): value is keyof ContactFormBase => {
  return typeof value === 'string' && propertiesOfContactFormBase.includes(value);
};

export const isIndividualContactForm = (value: unknown): value is IndividualContactForm => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === ContactType.individual)) return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if (!('lastName' in value && isString(value.lastName))) return false;

  return true;
};

export const isIndividualContactFormOrNull = (
  value: unknown,
): value is IndividualContactForm | null => {
  return value === null || isIndividualContactForm(value);
};

export const isArrayOfIndividualContactForm = (
  value: unknown,
): value is readonly IndividualContactForm[] => {
  return Array.isArray(value) && value.every(isIndividualContactForm);
};

export const isArrayOfIndividualContactFormOrNull = (
  value: unknown,
): value is readonly IndividualContactForm[] | null => {
  return value === null || isArrayOfIndividualContactForm(value);
};

const propertiesOfIndividualContactForm: readonly string[] = ['type', 'firstName', 'lastName'];

export const isKeyOfIndividualContactForm = (
  value: unknown,
): value is keyof IndividualContactForm => {
  return typeof value === 'string' && propertiesOfIndividualContactForm.includes(value);
};

export const isCompanyContactForm = (value: unknown): value is CompanyContactForm => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === ContactType.company)) return false;
  if (!('legalEntityName' in value && isString(value.legalEntityName))) return false;

  return true;
};

export const isCompanyContactFormOrNull = (value: unknown): value is CompanyContactForm | null => {
  return value === null || isCompanyContactForm(value);
};

export const isArrayOfCompanyContactForm = (
  value: unknown,
): value is readonly CompanyContactForm[] => {
  return Array.isArray(value) && value.every(isCompanyContactForm);
};

export const isArrayOfCompanyContactFormOrNull = (
  value: unknown,
): value is readonly CompanyContactForm[] | null => {
  return value === null || isArrayOfCompanyContactForm(value);
};

const propertiesOfCompanyContactForm: readonly string[] = ['type', 'legalEntityName'];

export const isKeyOfCompanyContactForm = (value: unknown): value is keyof CompanyContactForm => {
  return typeof value === 'string' && propertiesOfCompanyContactForm.includes(value);
};
